import axios from '../axiosConfig'; // Adjust the import path accordingly

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const FormNameInfo = {

    insertFormNameInfo: async (data) => {
        console.log(data)

        try {
            const apiUrl = `${WebApiUrl}/api/FormNameInfo`;
            console.log(apiUrl);
            const response = await axios.post(apiUrl, {
                formName: data.formName,
                formDescription: data.formDescription,
                moduleName: data.moduleName,
                moduleDescription: data.moduleDescription,
                formLink: data.formLink,
            }, {
                withCredentials: true,
                credentials: 'include',
            });

            console.log("Response:", response.data);
            return response;
        } catch (error) {
            console.error("Error:", error.message);

            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },

    // ************************* Get All ***************************

    getFormNameInfo: async () => {
        try {
            const apiUrl = `${WebApiUrl}/api/FormNameInfo/GetFormNameInfos`;
            //const apiUrl = `${express_server_url}/api/Station/GetStationMasters`;
            const response = await axios.post(apiUrl, {
                filter: [],
                order: [
                    {
                        propertyName: "string",
                        ascending: false
                    }
                ],
                pageNumber: 0,
                pageSize: 50000
            }, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
            console.error('Error:', error.message);
        }
    },


    // ************************* Delete ****************************
    deleteFormNameInfo: async (formId) => {
        try {
            const apiUrl = `${WebApiUrl}/api/FormNameInfo?formId=${formId}`;
            const response = await axios.delete(apiUrl, {
                withCredentials: true,
            });
            console.log('Delete Response:', response.data.result);
            return true;
        } catch (error) {
            console.error('Error:', error.message);
        }
    },

    // ************************* Get By Id ****************************
    getFormNameInfoById: async (id) => {
        try {
            const apiUrl = `${WebApiUrl}/api/FormNameInfo?formId=${id}`;
            const response = await axios.get(apiUrl, {}, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;
        } catch (error) {
            console.error('Error:', error.message);
        }
    },
    // *************************** Update ***************************
    updateFormNameInfo: async (data) => {
        console.log(data)

        try {
            const apiUrl = `${WebApiUrl}/api/FormNameInfo?formId=${data.id}`;
            console.log(apiUrl);
            const response = await axios.put(apiUrl, {
                id: Number(data.id),
                formName: data.formName,
                formDescription: data.formDescription,
                moduleName: data.moduleName,
                moduleDescription: data.moduleDescription,
                formLink: data.formLink,
            }, {
                withCredentials: true,
                credentials: 'include',
            });

            console.log("Response:", response.data);
            return response;
        } catch (error) {
            console.error("Error:", error.message);
            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },

    // ************************* Get filtered User Credential ***************************
    getFilteredFormNameInfo: async (filterData) => {
        const filteredData = filterData.map(data => ({
            fieldName: data.fieldName,
            operatorName: data.operatorName,
            compareValue: data.compareValue
        }));
        try {
            const apiUrl = `${WebApiUrl}/api/FormNameInfo/GetFormNameInfos`;
            const response = await axios.post(apiUrl, {
                filter: filteredData,
                order: [
                    {
                        propertyName: "string",
                        ascending: true
                    }
                ],
                pageNumber: 0,
                pageSize: 10000
            }, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
            console.error('Error:', error.message);
        }
    },
};

export default FormNameInfo;
